import _sfc_main from "./indexPC.vue2.mjs";
/* empty css              */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "footer-container" }, [_c("div", { staticClass: "left-container" }, [!_setup.isAudience || _setup.isAdmin ? _c(_setup.AudioControl, { staticClass: "left-container-item", on: { "click": function($event) {
    return _setup.handleControlClick("audioControl");
  } } }) : _vm._e(), !_setup.isAudience || _setup.isAdmin ? _c(_setup.VideoControl, { staticClass: "left-container-item", on: { "click": function($event) {
    return _setup.handleControlClick("videoControl");
  } } }) : _vm._e(), _setup.roomStore.isSpeakAfterTakingSeatMode && !_setup.isMaster ? _c(_setup.MemberApplyControl, { staticClass: "left-container-item", on: { "click": function($event) {
    return _setup.handleControlClick("MemberApplyControl");
  } } }) : _vm._e()], 1), _c("div", { staticClass: "center-container" }, [_c(_setup.ScreenShareControl, { staticClass: "center-container-item", on: { "click": function($event) {
    return _setup.handleControlClick("screenShareControl");
  } } }), _setup.isElectron ? _c(_setup.WhiteboardControl, { staticClass: "center-container-item", on: { "click": function($event) {
    return _setup.handleControlClick("whiteboard");
  } } }) : _vm._e(), _c(_setup.FullScreenControl, { staticClass: "center-container-item", on: { "click": function($event) {
    return _setup.handleControlClick("fullScreenControl");
  } } }), _c(_setup.ManageMemberControl, { staticClass: "center-container-item", on: { "click": function($event) {
    return _setup.handleControlClick("manageMemberControl");
  } } }), _c(_setup.InviteControl, { staticClass: "center-container-item", on: { "click": function($event) {
    return _setup.handleControlClick("inviteControl");
  } } }), _c(_setup.ChatControl, { staticClass: "center-container-item", on: { "click": function($event) {
    return _setup.handleControlClick("chatControl");
  } } }), _setup.roomStore.isSpeakAfterTakingSeatMode && (_setup.isMaster || _setup.isAdmin) ? _c(_setup.MasterApplyControl, { staticClass: "center-container-item", on: { "click": function($event) {
    return _setup.handleControlClick("MasterApplyControl");
  } } }) : _vm._e(), _c(_setup.MoreControl, { staticClass: "center-container-item", on: { "click": function($event) {
    return _setup.handleControlClick("moreControl");
  } } }), _c(_setup.AIControl, { staticClass: "center-container-item", on: { "click": function($event) {
    return _setup.handleControlClick("AIControl");
  } } }), _c(_setup.SettingControl, { staticClass: "center-container-item", on: { "click": function($event) {
    return _setup.handleControlClick("settingControl");
  } } }), _c(_setup.VirtualBackground, { staticClass: "center-container-item" }), !_setup.isElectron ? _c(_setup.BasicBeauty, { staticClass: "center-container-item" }) : _vm._e()], 1), _c("div", { staticClass: "right-container" }, [_c(_setup.EndControl)], 1)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "26cae62f"
);
const indexPc = __component__.exports;
export {
  indexPc as default
};
